import { render, staticRenderFns } from "./ReferForm.vue?vue&type=template&id=005e6e20&"
import script from "./ReferForm.vue?vue&type=script&lang=js&"
export * from "./ReferForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferForm.vue?vue&type=style&index=0&id=005e6e20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports